export const GET_DASHBOARD_BY_DOCTOR_ID_REQUEST =
    "GET_DASHBOARD_BY_DOCTOR_ID_REQUEST";
export const GET_DASHBOARD_BY_DOCTOR_ID_SUCCESS =
    "GET_DASHBOARD_BY_DOCTOR_ID_SUCCESS";
export const GET_DASHBOARD_BY_DOCTOR_ID_FAILURE =
    "GET_DASHBOARD_BY_DOCTOR_ID_FAILURE";

export const POST_SAVE_PROFILE_INFO_REQUEST = "POST_SAVE_PROFILE_INFO_REQUEST";
export const POST_SAVE_PROFILE_INFO_SUCCESS = "POST_SAVE_PROFILE_INFO_SUCCESS";
export const POST_SAVE_PROFILE_INFO_FAILURE = "POST_SAVE_PROFILE_INFO_FAILURE";

export const GET_PROFILE_INFO_REQUEST = "GET_PROFILE_INFO_REQUEST";
export const GET_PROFILE_INFO_SUCCESS = "GET_PROFILE_INFO_SUCCESS";
export const GET_PROFILE_INFO_FAILURE = "GET_PROFILE_INFO_FAILURE";

export const POST_SAVE_ADDITIONAL_INFO_REQUEST =
    "POST_SAVE_ADDITIONAL_INFO_REQUEST";
export const POST_SAVE_ADDITIONAL_INFO_SUCCESS =
    "POST_SAVE_ADDITIONAL_INFO_SUCCESS";
export const POST_SAVE_ADDITIONAL_INFO_FAILURE =
    "POST_SAVE_ADDITIONAL_INFO_FAILURE";

export const GET_ADDITIONAL_INFO_REQUEST = "GET_ADDITIONAL_INFO_REQUEST";
export const GET_ADDITIONAL_INFO_SUCCESS = "GET_ADDITIONAL_INFO_SUCCESS";
export const GET_ADDITIONAL_INFO_FAILURE = "GET_ADDITIONAL_INFO_FAILURE";

export const POST_PROFILE_CERTIFICATES_REQUEST =
    "POST_PROFILE_CERTIFICATES_REQUEST";
export const POST_PROFILE_CERTIFICATES_SUCCESS =
    "POST_PROFILE_CERTIFICATES_SUCCESS";
export const POST_PROFILE_CERTIFICATES_FAILURE =
    "POST_PROFILE_CERTIFICATES_FAILURE";

export const GET_CLINIC_DOCTOR_DETAILS_REQUEST =
    "GET_CLINIC_DOCTOR_DETAILS_REQUEST";
export const GET_CLINIC_DOCTOR_DETAILS_SUCCESS =
    "GET_CLINIC_DOCTOR_DETAILS_SUCCESS";
export const GET_CLINIC_DOCTOR_DETAILS_FAILURE =
    "GET_CLINIC_DOCTOR_DETAILS_FAILURE";

export const POST_SAVE_FEES_REQUEST = "POST_SAVE_FEES_REQUEST";
export const POST_SAVE_FEES_SUCCESS = "POST_SAVE_FEES_SUCCESS";
export const POST_SAVE_FEES_FAILURE = "POST_SAVE_FEES_FAILURE";

export const GET_FEES_REQUEST = "GET_FEES_REQUEST";
export const GET_FEES_SUCCESS = "GET_FEES_SUCCESS";
export const GET_FEES_FAILURE = "GET_FEES_FAILURE";

export const GET_ALL_ADDITIONAL_SERVICES_REQUEST =
    "GET_ALL_ADDITIONAL_SERVICES_REQUEST";
export const GET_ALL_ADDITIONAL_SERVICES_SUCCESS =
    "GET_ALL_ADDITIONAL_SERVICES_SUCCESS";
export const GET_ALL_ADDITIONAL_SERVICES_FAILURE =
    "GET_ALL_ADDITIONAL_SERVICES_FAILURE";

export const POST_SAVE_ADDITIONAL_SERVICE_INFO_REQUEST =
    "POST_SAVE_ADDITIONAL_SERVICE_INFO_REQUEST";
export const POST_SAVE_ADDITIONAL_SERVICE_INFO_SUCCESS =
    "POST_SAVE_ADDITIONAL_SERVICE_INFO_SUCCESS";
export const POST_SAVE_ADDITIONAL_SERVICE_INFO_FAILURE =
    "POST_SAVE_ADDITIONAL_SERVICE_INFO_FAILURE";

export const DELETE_SERVICE_BY_ID_REQUEST = "DELETE_SERVICE_BY_ID_REQUEST";
export const DELETE_SERVICE_BY_ID_SUCCESS = "DELETE_SERVICE_BY_ID_SUCCESS";
export const DELETE_SERVICE_BY_ID_FAILURE = "DELETE_SERVICE_BY_ID_FAILURE";

export const POST_SAVE_DEFAULTTIMING_REQUEST =
    "POST_SAVE_DEFAULTTIMING_REQUEST";
export const POST_SAVE_DEFAULTTIMING_SUCCESS =
    "POST_SAVE_DEFAULTTIMING_SUCCESS";
export const POST_SAVE_DEFAULTTIMING_FAILURE =
    "POST_SAVE_DEFAULTTIMING_FAILURE";

export const GET_DEFAULT_TIMING_REQUEST = "GET_DEFAULT_TIMING_REQUEST";
export const GET_DEFAULT_TIMING_SUCCESS = "GET_DEFAULT_TIMING_SUCCESS";
export const GET_DEFAULT_TIMING_FAILURE = "GET_DEFAULT_TIMING_FAILURE";

export const POST_SAVE_CUSTOM_TIMING_REQUEST =
    "POST_SAVE_CUSTOM_TIMING_REQUEST";
export const POST_SAVE_CUSTOM_TIMING_SUCCESS =
    "POST_SAVE_CUSTOM_TIMING_SUCCESS";
export const POST_SAVE_CUSTOM_TIMING_FAILURE =
    "POST_SAVE_CUSTOM_TIMING_FAILURE";

export const GET_CUSTOM_TIMING_REQUEST = "GET_CUSTOM_TIMING_REQUEST";
export const GET_CUSTOM_TIMING_SUCCESS = "GET_CUSTOM_TIMING_SUCCESS";
export const GET_CUSTOM_TIMING_FAILURE = "GET_CUSTOM_TIMING_FAILURE";

export const DELETE_DEFAULT_TIMING_BY_ID_REQUEST =
    "DELETE_DEFAULT_TIMING_BY_ID_REQUEST";
export const DELETE_DEFAULT_TIMING_BY_ID_SUCCESS =
    "DELETE_DEFAULT_TIMING_BY_ID_SUCCESS";
export const DELETE_DEFAULT_TIMING_BY_ID_FAILURE =
    "DELETE_DEFAULT_TIMING_BY_ID_FAILURE";

export const DELETE_CUSTOM_TIMING_BY_ID_REQUEST =
    "DELETE_CUSTOM_TIMING_BY_ID_REQUEST";
export const DELETE_CUSTOM_TIMING_BY_ID_SUCCESS =
    "DELETE_CUSTOM_TIMING_BY_ID_SUCCESS";
export const DELETE_CUSTOM_TIMING_BY_ID_FAILURE =
    "DELETE_CUSTOM_TIMING_BY_ID_FAILURE";

export const GET_CLINIC_DETAILS_BY_DOCTOR_ID_REQUEST =
    "GET_CLINIC_DETAILS_BY_DOCTOR_ID_REQUEST";
export const GET_CLINIC_DETAILS_BY_DOCTOR_ID_SUCCESS =
    "GET_CLINIC_DETAILS_BY_DOCTOR_ID_SUCCESS";
export const GET_CLINIC_DETAILS_BY_DOCTOR_ID_FAILURE =
    "GET_CLINIC_DETAILS_BY_DOCTOR_ID_FAILURE";

export const GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_REQUEST =
    "GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_REQUEST";
export const GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_SUCCESS =
    "GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_SUCCESS";
export const GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_FAILURE =
    "GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_FAILURE";

export const CLEAR_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_DATA = 'CLEAR_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_DATA';

export const GET_ALL_CLINIC_REQUESTS_REQUEST =
    "GET_ALL_CLINIC_REQUESTS_REQUEST";
export const GET_ALL_CLINIC_REQUESTS_SUCCESS =
    "GET_ALL_CLINIC_REQUESTS_SUCCESS";
export const GET_ALL_CLINIC_REQUESTS_FAILURE =
    "GET_ALL_CLINIC_REQUESTS_FAILURE";

export const POST_SEND_DOCTOR_CLINIC_REQUEST_REQUEST =
    "POST_SEND_DOCTOR_CLINIC_REQUEST_REQUEST";
export const POST_SEND_DOCTOR_CLINIC_REQUEST_SUCCESS =
    "POST_SEND_DOCTOR_CLINIC_REQUEST_SUCCESS";
export const POST_SEND_DOCTOR_CLINIC_REQUEST_FAILURE =
    "POST_SEND_DOCTOR_CLINIC_REQUEST_FAILURE";

export const GET_ALL_DOCTOR_CLINIC_REQUESTS_REQUEST =
    "GET_ALL_DOCTOR_CLINIC_REQUESTS_REQUEST";
export const GET_ALL_DOCTOR_CLINIC_REQUESTS_SUCCESS =
    "GET_ALL_DOCTOR_CLINIC_REQUESTS_SUCCESS";
export const GET_ALL_DOCTOR_CLINIC_REQUESTS_FAILURE =
    "GET_ALL_DOCTOR_CLINIC_REQUESTS_FAILURE";

export const POST_DOCTORS_PATIENT_REQUEST = "POST_DOCTORS_PATIENT_REQUEST";
export const POST_DOCTORS_PATIENT_SUCCESS = "POST_DOCTORS_PATIENT_SUCCESS";
export const POST_DOCTORS_PATIENT_FAILURE = "POST_DOCTORS_PATIENT_FAILURE";

export const POST_FINANCE_DATA_REQUEST = "POST_FINANCE_DATA_REQUEST";
export const POST_FINANCE_DATA_SUCCESS = "POST_FINANCE_DATA_SUCCESS";
export const POST_FINANCE_DATA_FAILURE = "POST_FINANCE_DATA_FAILURE";

export const GET_CLINIC_DOCTOR_REQUEST = "GET_CLINIC_DOCTOR_REQUEST";
export const GET_CLINIC_DOCTOR_SUCCESS = "GET_CLINIC_DOCTOR_SUCCESS";
export const GET_CLINIC_DOCTOR_FAILURE = "GET_CLINIC_DOCTOR_FAILURE";

export const GET_CHAT_APPOINTMENT_BY_DOCTOR_REQUEST =
    "GET_CHAT_APPOINTMENT_BY_DOCTOR_REQUEST";
export const GET_CHAT_APPOINTMENT_BY_DOCTOR_SUCCESS =
    "GET_CHAT_APPOINTMENT_BY_DOCTOR_SUCCESS";
export const GET_CHAT_APPOINTMENT_BY_DOCTOR_FAILURE =
    "GET_CHAT_APPOINTMENT_BY_DOCTOR_FAILURE";

export const GET_EMERGENCY_CALL_BY_DOCTOR_REQUEST =
    "GET_EMERGENCY_CALL_BY_DOCTOR_REQUEST";
export const GET_EMERGENCY_CALL_BY_DOCTOR_SUCCESS =
    "GET_EMERGENCY_CALL_BY_DOCTOR_SUCCESS";
export const GET_EMERGENCY_CALL_BY_DOCTOR_FAILURE =
    "GET_EMERGENCY_CALL_BY_DOCTOR_FAILURE";

export const CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_REQUEST =
    "CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_REQUEST";
export const CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_SUCCESS =
    "CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_SUCCESS";
export const CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_FAILURE =
    "CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_FAILURE";

export const CREATE_CLINIC_DOCTOR_SERVICES_REQUEST =
    "CREATE_CLINIC_DOCTOR_SERVICES_REQUEST";
export const CREATE_CLINIC_DOCTOR_SERVICES_SUCCESS =
    "CREATE_CLINIC_DOCTOR_SERVICES_SUCCESS";
export const CREATE_CLINIC_DOCTOR_SERVICES_FAILURE =
    "CREATE_CLINIC_DOCTOR_SERVICES_FAILURE";

export const POST_SAVE_FAQ_REQUEST = "POST_SAVE_FAQ_REQUEST";
export const POST_SAVE_FAQ_SUCCESS = "POST_SAVE_FAQ_SUCCESS";
export const POST_SAVE_FAQ_FAILURE = "POST_SAVE_FAQ_FAILURE";

export const GET_FAQ_REQUEST = "GET_FAQ_REQUEST";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_FAILURE = "GET_FAQ_FAILURE";

export const DELETE_FAQ_REQUEST = "DELETE_FAQ_REQUEST";
export const DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS";
export const DELETE_FAQ_FAILURE = "DELETE_FAQ_FAILURE";

export const GET_ALL_INVOICE_DOCTOR_BY_ID_REQUEST =
    "GET_ALL_INVOICE_DOCTOR_BY_ID_REQUEST";
export const GET_ALL_INVOICE_DOCTOR_BY_ID_SUCCESS =
    "GET_ALL_INVOICE_DOCTOR_BY_ID_SUCCESS";
export const GET_ALL_INVOICE_DOCTOR_BY_ID_FAILURE =
    "GET_ALL_INVOICE_DOCTOR_BY_ID_FAILURE";

export const GET_DIAGNOSTIC_BY_ID_REQUEST = "GET_DIAGNOSTIC_BY_ID_REQUEST";
export const GET_DIAGNOSTIC_BY_ID_SUCCESS = "GET_DIAGNOSTIC_BY_ID_SUCCESS";
export const GET_DIAGNOSTIC_BY_ID_FAILURE = "GET_DIAGNOSTIC_BY_ID_FAILURE";

export const GET_ALL_APPOINTMENT_DETAIL_REQUEST =
    "GET_ALL_APPOINTMENT_DETAIL_REQUEST";
export const GET_ALL_APPOINTMENT_DETAIL_SUCCESS =
    "GET_ALL_APPOINTMENT_DETAIL_SUCCESS";
export const GET_ALL_APPOINTMENT_DETAIL_FAILURE =
    "GET_ALL_APPOINTMENT_DETAIL_FAILURE";

export const POST_ADDITIONAL_SERVICES_REQUEST =
    "POST_ADDITIONAL_SERVICES_REQUEST";
export const POST_ADDITIONAL_SERVICES_SUCCESS =
    "POST_ADDITIONAL_SERVICES_SUCCESS";
export const POST_ADDITIONAL_SERVICES_FAILURE =
    "POST_ADDITIONAL_SERVICES_FAILURE";

export const GET_ADDITIONAL_SERVICE_INFO_REQUEST =
    "GET_ADDITIONAL_SERVICE_INFO_REQUEST";
export const GET_ADDITIONAL_SERVICE_INFO_SUCCESS =
    "GET_ADDITIONAL_SERVICE_INFO_SUCCESS";
export const GET_ADDITIONAL_SERVICE_INFO_FAILURE =
    "GET_ADDITIONAL_SERVICE_INFO_FAILURE";

export const POST_DIAGNOSTIC_REPORT_REQUEST = "POST_DIAGNOSTIC_REPORT_REQUEST";
export const POST_DIAGNOSTIC_REPORT_SUCCESS = "POST_DIAGNOSTIC_REPORT_SUCCESS";
export const POST_DIAGNOSTIC_REPORT_FAILURE = "POST_DIAGNOSTIC_REPORT_FAILURE";

export const GET_ALL_APPOINTMENT_DETAIL_LIST_REQUEST =
    "GET_ALL_APPOINTMENT_DETAIL_LIST_REQUEST";
export const GET_ALL_APPOINTMENT_DETAIL_LIST_SUCCESS =
    "GET_ALL_APPOINTMENT_DETAIL_LIST_SUCCESS";
export const GET_ALL_APPOINTMENT_DETAIL_LIST_FAILURE =
    "GET_ALL_APPOINTMENT_DETAIL_LIST_FAILURE";

export const DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_REQUEST =
    "DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_REQUEST";
export const DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_SUCCESS =
    "DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_SUCCESS";
export const DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_FAILURE =
    "DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_FAILURE";

export const POST_SAVE_INVOICE_SETTING_REQUEST =
    "POST_SAVE_INVOICE_SETTING_REQUEST";
export const POST_SAVE_INVOICE_SETTING_SUCCESS =
    "POST_SAVE_INVOICE_SETTING_SUCCESS";
export const POST_SAVE_INVOICE_SETTING_FAILURE =
    "POST_SAVE_INVOICE_SETTING_FAILURE";

export const GET_INVOICE_SETTING_BY_GUID_REQUEST =
    "GET_INVOICE_SETTING_BY_GUID_REQUEST";
export const GET_INVOICE_SETTING_BY_GUID_SUCCESS =
    "GET_INVOICE_SETTING_BY_GUID_SUCCESS";
export const GET_INVOICE_SETTING_BY_GUID_FAILURE =
    "GET_INVOICE_SETTING_BY_GUID_FAILURE";

export const GET_INVOICE_REQUEST = "GET_INVOICE_REQUEST";
export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS";
export const GET_INVOICE_FAILURE = "GET_INVOICE_FAILURE";

export const POST_SAVE_INVOICE_LIST_REQUEST = "POST_SAVE_INVOICE_LIST_REQUEST";
export const POST_SAVE_INVOICE_LIST_SUCCESS = "POST_SAVE_INVOICE_LIST_SUCCESS";
export const POST_SAVE_INVOICE_LIST_FAILURE = "POST_SAVE_INVOICE_LIST_FAILURE";

export const POST_MARK_APPOINTMENT_AS_COMPLETE_REQUEST =
    "POST_MARK_APPOINTMENT_AS_COMPLETE_REQUEST";
export const POST_MARK_APPOINTMENT_AS_COMPLETE_SUCCESS =
    "POST_MARK_APPOINTMENT_AS_COMPLETE_SUCCESS";
export const POST_MARK_APPOINTMENT_AS_COMPLETE_FAILURE =
    "POST_MARK_APPOINTMENT_AS_COMPLETE_FAILURE";

export const POST_UPDATE_DOCTOR_FEES_CURRENCY_REQUEST =
    "POST_UPDATE_DOCTOR_FEES_CURRENCY_REQUEST";
export const POST_UPDATE_DOCTOR_FEES_CURRENCY_SUCCESS =
    "POST_UPDATE_DOCTOR_FEES_CURRENCY_SUCCESS";
export const POST_UPDATE_DOCTOR_FEES_CURRENCY_FAILURE =
    "POST_UPDATE_DOCTOR_FEES_CURRENCY_FAILURE";

export const GET_MASS_MESSAGES_REQUEST = "GET_MASS_MESSAGES_REQUEST";
export const GET_MASS_MESSAGES_SUCCESS = "GET_MASS_MESSAGES_SUCCESS";
export const GET_MASS_MESSAGES_FAILURE = "GET_MASS_MESSAGES_FAILURE";

export const POST_CREATE_MASS_MESSAGE_REQUEST =
    "POST_CREATE_MASS_MESSAGE_REQUEST";
export const POST_CREATE_MASS_MESSAGE_SUCCESS =
    "POST_CREATE_MASS_MESSAGE_SUCCESS";
export const POST_CREATE_MASS_MESSAGE_FAILURE =
    "POST_CREATE_MASS_MESSAGE_FAILURE";

export const POST_UPDATE_EMERGENCY_CALL_REQUEST =
    "POST_UPDATE_EMERGENCY_CALL_REQUEST";
export const POST_UPDATE_EMERGENCY_CALL_SUCCESS =
    "POST_UPDATE_EMERGENCY_CALL_SUCCESS";
export const POST_UPDATE_EMERGENCY_CALL_FAILURE =
    "POST_UPDATE_EMERGENCY_CALL_FAILURE";

export const POST_BOOKED_EMERGENCY_APPOINTMENT_REQUEST =
    "POST_BOOKED_EMERGENCY_APPOINTMENT_REQUEST";
export const POST_BOOKED_EMERGENCY_APPOINTMENT_SUCCESS =
    "POST_BOOKED_EMERGENCY_APPOINTMENT_SUCCESS";
export const POST_BOOKED_EMERGENCY_APPOINTMENT_FAILURE =
    "POST_BOOKED_EMERGENCY_APPOINTMENT_FAILURE";

export const GET_LIST_PATIENT_DETAILS_BY_DOCTOR_REQUEST =
    "GET_LIST_PATIENT_DETAILS_BY_DOCTOR_REQUEST";
export const GET_LIST_PATIENT_DETAILS_BY_DOCTOR_SUCCESS =
    "GET_LIST_PATIENT_DETAILS_BY_DOCTOR_SUCCESS";
export const GET_LIST_PATIENT_DETAILS_BY_DOCTOR_FAILURE =
    "GET_LIST_PATIENT_DETAILS_BY_DOCTOR_FAILURE";

export const POST_GET_CHAT_HISTORY_REQUESTT = "POST_GET_CHAT_HISTORY_REQUESTT";
export const POST_GET_CHAT_HISTORY_SUCCESSS = "POST_GET_CHAT_HISTORY_SUCCESSS";
export const POST_GET_CHAT_HISTORY_FAILUREE = "POST_GET_CHAT_HISTORY_FAILUREE";

export const POST_UPDATE_CHAT_APPOINTMENT_REQUEST =
    "POST_UPDATE_CHAT_APPOINTMENT_REQUEST";
export const POST_UPDATE_CHAT_APPOINTMENT_SUCCESS =
    "POST_UPDATE_CHAT_APPOINTMENT_SUCCESS";
export const POST_UPDATE_CHAT_APPOINTMENT_FAILURE =
    "POST_UPDATE_CHAT_APPOINTMENT_FAILURE";

export const POST_UPDATE_CHAT_NOTIFICATION_REQUEST =
    "POST_UPDATE_CHAT_NOTIFICATION_REQUEST";
export const POST_UPDATE_CHAT_NOTIFICATION_SUCCESS =
    "POST_UPDATE_CHAT_NOTIFICATION_SUCCESS";
export const POST_UPDATE_CHAT_NOTIFICATION_FAILURE =
    "POST_UPDATE_CHAT_NOTIFICATION_FAILURE";

export const POST_UPDATE_PDF_REQUEST = "POST_UPDATE_PDF_REQUEST";
export const POST_UPDATE_PDF_SUCCESS = "POST_UPDATE_PDF_SUCCESS";
export const POST_UPDATE_PDF_FAILURE = "POST_UPDATE_PDF_FAILURE";

export const GET_CHAT_NOTIFICATION_REQUEST = "GET_CHAT_NOTIFICATION_REQUEST";
export const GET_CHAT_NOTIFICATION_SUCCESS = "GET_CHAT_NOTIFICATION_SUCCESS";
export const GET_CHAT_NOTIFICATION_FAILURE = "GET_CHAT_NOTIFICATION_FAILURE";

export const POST_ALL_CLINIC_REQUEST = "POST_ALL_CLINIC_REQUEST";
export const POST_ALL_CLINIC_SUCCESS = "POST_ALL_CLINIC_SUCCESS";
export const POST_ALL_CLINIC_FAILURE = "POST_ALL_CLINIC_FAILURE";

export const POST_SEARCH_CLINIC_APPOINTMENT_REQUEST = "POST_SEARCH_CLINIC_APPOINTMENT_REQUEST";
export const POST_SEARCH_CLINIC_APPOINTMENT_SUCCESS = "POST_SEARCH_CLINIC_APPOINTMENT_SUCCESS";
export const POST_SEARCH_CLINIC_APPOINTMENT_FAILURE = "POST_SEARCH_CLINIC_APPOINTMENT_FAILURE";

const actionTypeDoctor = {
    GET_DASHBOARD_BY_DOCTOR_ID_REQUEST,
    GET_DASHBOARD_BY_DOCTOR_ID_SUCCESS,
    GET_DASHBOARD_BY_DOCTOR_ID_FAILURE,

    POST_SAVE_PROFILE_INFO_REQUEST,
    POST_SAVE_PROFILE_INFO_SUCCESS,
    POST_SAVE_PROFILE_INFO_FAILURE,

    GET_PROFILE_INFO_REQUEST,
    GET_PROFILE_INFO_SUCCESS,
    GET_PROFILE_INFO_FAILURE,

    POST_SAVE_ADDITIONAL_INFO_REQUEST,
    POST_SAVE_ADDITIONAL_INFO_SUCCESS,
    POST_SAVE_ADDITIONAL_INFO_FAILURE,

    GET_ADDITIONAL_INFO_REQUEST,
    GET_ADDITIONAL_INFO_SUCCESS,
    GET_ADDITIONAL_INFO_FAILURE,

    POST_PROFILE_CERTIFICATES_REQUEST,
    POST_PROFILE_CERTIFICATES_SUCCESS,
    POST_PROFILE_CERTIFICATES_FAILURE,

    GET_CLINIC_DOCTOR_DETAILS_REQUEST,
    GET_CLINIC_DOCTOR_DETAILS_SUCCESS,
    GET_CLINIC_DOCTOR_DETAILS_FAILURE,

    POST_SAVE_FEES_REQUEST,
    POST_SAVE_FEES_SUCCESS,
    POST_SAVE_FEES_FAILURE,

    GET_FEES_REQUEST,
    GET_FEES_SUCCESS,
    GET_FEES_FAILURE,

    GET_ALL_ADDITIONAL_SERVICES_REQUEST,
    GET_ALL_ADDITIONAL_SERVICES_SUCCESS,
    GET_ALL_ADDITIONAL_SERVICES_FAILURE,

    POST_SAVE_ADDITIONAL_SERVICE_INFO_REQUEST,
    POST_SAVE_ADDITIONAL_SERVICE_INFO_SUCCESS,
    POST_SAVE_ADDITIONAL_SERVICE_INFO_FAILURE,

    DELETE_SERVICE_BY_ID_REQUEST,
    DELETE_SERVICE_BY_ID_SUCCESS,
    DELETE_SERVICE_BY_ID_FAILURE,

    POST_SAVE_DEFAULTTIMING_REQUEST,
    POST_SAVE_DEFAULTTIMING_SUCCESS,
    POST_SAVE_DEFAULTTIMING_FAILURE,

    GET_DEFAULT_TIMING_REQUEST,
    GET_DEFAULT_TIMING_SUCCESS,
    GET_DEFAULT_TIMING_FAILURE,

    POST_SAVE_CUSTOM_TIMING_REQUEST,
    POST_SAVE_CUSTOM_TIMING_SUCCESS,
    POST_SAVE_CUSTOM_TIMING_FAILURE,

    GET_CUSTOM_TIMING_REQUEST,
    GET_CUSTOM_TIMING_SUCCESS,
    GET_CUSTOM_TIMING_FAILURE,

    DELETE_DEFAULT_TIMING_BY_ID_REQUEST,
    DELETE_DEFAULT_TIMING_BY_ID_SUCCESS,
    DELETE_DEFAULT_TIMING_BY_ID_FAILURE,

    DELETE_CUSTOM_TIMING_BY_ID_REQUEST,
    DELETE_CUSTOM_TIMING_BY_ID_SUCCESS,
    DELETE_CUSTOM_TIMING_BY_ID_FAILURE,

    GET_CLINIC_DETAILS_BY_DOCTOR_ID_REQUEST,
    GET_CLINIC_DETAILS_BY_DOCTOR_ID_SUCCESS,
    GET_CLINIC_DETAILS_BY_DOCTOR_ID_FAILURE,

    GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_REQUEST,
    GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_SUCCESS,
    GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_FAILURE,

    CLEAR_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_DATA,

    GET_ALL_CLINIC_REQUESTS_REQUEST,
    GET_ALL_CLINIC_REQUESTS_SUCCESS,
    GET_ALL_CLINIC_REQUESTS_FAILURE,

    POST_SEND_DOCTOR_CLINIC_REQUEST_REQUEST,
    POST_SEND_DOCTOR_CLINIC_REQUEST_SUCCESS,
    POST_SEND_DOCTOR_CLINIC_REQUEST_FAILURE,

    GET_ALL_DOCTOR_CLINIC_REQUESTS_REQUEST,
    GET_ALL_DOCTOR_CLINIC_REQUESTS_SUCCESS,
    GET_ALL_DOCTOR_CLINIC_REQUESTS_FAILURE,

    POST_DOCTORS_PATIENT_REQUEST,
    POST_DOCTORS_PATIENT_SUCCESS,
    POST_DOCTORS_PATIENT_FAILURE,

    POST_FINANCE_DATA_REQUEST,
    POST_FINANCE_DATA_SUCCESS,
    POST_FINANCE_DATA_FAILURE,

    GET_CLINIC_DOCTOR_REQUEST,
    GET_CLINIC_DOCTOR_SUCCESS,
    GET_CLINIC_DOCTOR_FAILURE,

    GET_CHAT_APPOINTMENT_BY_DOCTOR_REQUEST,
    GET_CHAT_APPOINTMENT_BY_DOCTOR_SUCCESS,
    GET_CHAT_APPOINTMENT_BY_DOCTOR_FAILURE,

    GET_EMERGENCY_CALL_BY_DOCTOR_REQUEST,
    GET_EMERGENCY_CALL_BY_DOCTOR_SUCCESS,
    GET_EMERGENCY_CALL_BY_DOCTOR_FAILURE,

    CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_REQUEST,
    CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_SUCCESS,
    CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_FAILURE,

    CREATE_CLINIC_DOCTOR_SERVICES_REQUEST,
    CREATE_CLINIC_DOCTOR_SERVICES_SUCCESS,
    CREATE_CLINIC_DOCTOR_SERVICES_FAILURE,

    POST_SAVE_FAQ_REQUEST,
    POST_SAVE_FAQ_SUCCESS,
    POST_SAVE_FAQ_FAILURE,

    GET_FAQ_REQUEST,
    GET_FAQ_SUCCESS,
    GET_FAQ_FAILURE,

    DELETE_FAQ_REQUEST,
    DELETE_FAQ_SUCCESS,
    DELETE_FAQ_FAILURE,

    GET_ALL_INVOICE_DOCTOR_BY_ID_REQUEST,
    GET_ALL_INVOICE_DOCTOR_BY_ID_SUCCESS,
    GET_ALL_INVOICE_DOCTOR_BY_ID_FAILURE,

    GET_DIAGNOSTIC_BY_ID_REQUEST,
    GET_DIAGNOSTIC_BY_ID_SUCCESS,
    GET_DIAGNOSTIC_BY_ID_FAILURE,

    GET_ALL_APPOINTMENT_DETAIL_REQUEST,
    GET_ALL_APPOINTMENT_DETAIL_SUCCESS,
    GET_ALL_APPOINTMENT_DETAIL_FAILURE,

    POST_ADDITIONAL_SERVICES_REQUEST,
    POST_ADDITIONAL_SERVICES_SUCCESS,
    POST_ADDITIONAL_SERVICES_FAILURE,

    GET_ADDITIONAL_SERVICE_INFO_REQUEST,
    GET_ADDITIONAL_SERVICE_INFO_SUCCESS,
    GET_ADDITIONAL_SERVICE_INFO_FAILURE,

    POST_DIAGNOSTIC_REPORT_REQUEST,
    POST_DIAGNOSTIC_REPORT_SUCCESS,
    POST_DIAGNOSTIC_REPORT_FAILURE,

    GET_ALL_APPOINTMENT_DETAIL_LIST_REQUEST,
    GET_ALL_APPOINTMENT_DETAIL_LIST_SUCCESS,
    GET_ALL_APPOINTMENT_DETAIL_LIST_FAILURE,

    DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_REQUEST,
    DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_SUCCESS,
    DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_FAILURE,

    POST_SAVE_INVOICE_SETTING_REQUEST,
    POST_SAVE_INVOICE_SETTING_SUCCESS,
    POST_SAVE_INVOICE_SETTING_FAILURE,

    GET_INVOICE_SETTING_BY_GUID_REQUEST,
    GET_INVOICE_SETTING_BY_GUID_SUCCESS,
    GET_INVOICE_SETTING_BY_GUID_FAILURE,

    GET_INVOICE_REQUEST,
    GET_INVOICE_SUCCESS,
    GET_INVOICE_FAILURE,

    POST_SAVE_INVOICE_LIST_REQUEST,
    POST_SAVE_INVOICE_LIST_SUCCESS,
    POST_SAVE_INVOICE_LIST_FAILURE,

    POST_MARK_APPOINTMENT_AS_COMPLETE_REQUEST,
    POST_MARK_APPOINTMENT_AS_COMPLETE_SUCCESS,
    POST_MARK_APPOINTMENT_AS_COMPLETE_FAILURE,

    POST_UPDATE_DOCTOR_FEES_CURRENCY_REQUEST,
    POST_UPDATE_DOCTOR_FEES_CURRENCY_SUCCESS,
    POST_UPDATE_DOCTOR_FEES_CURRENCY_FAILURE,

    GET_MASS_MESSAGES_REQUEST,
    GET_MASS_MESSAGES_SUCCESS,
    GET_MASS_MESSAGES_FAILURE,

    POST_CREATE_MASS_MESSAGE_REQUEST,
    POST_CREATE_MASS_MESSAGE_SUCCESS,
    POST_CREATE_MASS_MESSAGE_FAILURE,

    POST_UPDATE_EMERGENCY_CALL_REQUEST,
    POST_UPDATE_EMERGENCY_CALL_SUCCESS,
    POST_UPDATE_EMERGENCY_CALL_FAILURE,

    POST_BOOKED_EMERGENCY_APPOINTMENT_REQUEST,
    POST_BOOKED_EMERGENCY_APPOINTMENT_SUCCESS,
    POST_BOOKED_EMERGENCY_APPOINTMENT_FAILURE,

    GET_LIST_PATIENT_DETAILS_BY_DOCTOR_REQUEST,
    GET_LIST_PATIENT_DETAILS_BY_DOCTOR_SUCCESS,
    GET_LIST_PATIENT_DETAILS_BY_DOCTOR_FAILURE,

    POST_GET_CHAT_HISTORY_REQUESTT,
    POST_GET_CHAT_HISTORY_SUCCESSS,
    POST_GET_CHAT_HISTORY_FAILUREE,

    POST_UPDATE_CHAT_APPOINTMENT_REQUEST,
    POST_UPDATE_CHAT_APPOINTMENT_SUCCESS,
    POST_UPDATE_CHAT_APPOINTMENT_FAILURE,

    POST_UPDATE_CHAT_NOTIFICATION_REQUEST,
    POST_UPDATE_CHAT_NOTIFICATION_SUCCESS,
    POST_UPDATE_CHAT_NOTIFICATION_FAILURE,

    POST_UPDATE_PDF_REQUEST,
    POST_UPDATE_PDF_SUCCESS,
    POST_UPDATE_PDF_FAILURE,

    GET_CHAT_NOTIFICATION_REQUEST,
    GET_CHAT_NOTIFICATION_SUCCESS,
    GET_CHAT_NOTIFICATION_FAILURE,

    POST_ALL_CLINIC_REQUEST,
    POST_ALL_CLINIC_SUCCESS,
    POST_ALL_CLINIC_FAILURE,

    POST_SEARCH_CLINIC_APPOINTMENT_REQUEST,
    POST_SEARCH_CLINIC_APPOINTMENT_SUCCESS,
    POST_SEARCH_CLINIC_APPOINTMENT_FAILURE
};

export default actionTypeDoctor;
